
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class TigerSchoolBanner extends Vue {
  @Prop() public bannerOption!: any;
}
